module.exports = __webpack_public_path__ + "static/media/photo8@2x.eafcb8a0.jpg";